import React from 'react';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import styles from './MedicalRecordStatusBadge.module.scss';

/**
 * Displays HealthLake promotion status for a document.
 * Renders null for 'not_promoted' to keep the file browser uncluttered.
 */
const MedicalRecordStatusBadge = ({ status, promotedAt, promotionSource }) => {
  if (!status || status === 'not_promoted') {
    return null;
  }

  if (status === 'promoted') {
    const tooltipTarget = `med-record-badge-${promotedAt?.replace(/[:.]/g, '-') || 'promoted'}`;
    const tooltipText = promotedAt ? `Promoted at: ${promotedAt}${promotionSource ? ` via ${promotionSource}` : ''}` : 'Promoted';
    return (
      <span data-testid="med-record-badge-promoted" data-pr-tooltip={tooltipText} className={`${tooltipTarget} ${styles.badgeWrapper}`}>
        <Tag className={`${tooltipTarget} ${styles.badge}`} severity="success" value="Medical Record ✓" />
        <Tooltip target={`.${tooltipTarget}`} />
      </span>
    );
  }

  if (status === 'pending_promotion') {
    return (
      <span data-testid="med-record-badge-pending" className={styles.badgeWrapper}>
        <Tag className={styles.badge} severity="warning">
          <span className="d-flex align-items-center gap-1">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: '0.75rem' }} data-testid="spinner" />
            Promoting…
          </span>
        </Tag>
      </span>
    );
  }

  if (status === 'failed_promotion') {
    return (
      <span data-testid="med-record-badge-failed" className={styles.badgeWrapper}>
        <Tag className={styles.badge} severity="danger">
          <span className="d-flex align-items-center gap-1">
            Promotion failed
            <button
              type="button"
              className={styles.retryButton}
              aria-label="Retry promotion"
              data-testid="retry-promotion"
              onClick={(e) => e.stopPropagation()}
            >
              <i className="pi pi-refresh" style={{ fontSize: '0.75rem' }} />
            </button>
          </span>
        </Tag>
      </span>
    );
  }

  return null;
};

export default MedicalRecordStatusBadge;
